// @flow
import VerifiableAccount from './VerifiableAccount';

export const PlaidAccountTypes = {
  depository: 'depository',
  credit: 'credit',
  loan: 'loan',
};

export const PlaidAccountSubTypes = {
  checking: 'checking',
  savings: 'savings',
  credit_card: 'credit card',
  student: 'student',
};

export type TPlaidAccountTypes = $Values<typeof PlaidAccountTypes>;
export type TPlaidAccountSubTypes = $Values<typeof PlaidAccountSubTypes>;

export type TPlaidAccountInstitution = {
  name: string,
  institution_id: string,
};

export type TPlaidAccountOptions = {
  id: string,
  name: string,
  institution: TPlaidAccountInstitution,
  mask: string,
  type: TPlaidAccountTypes,
  subtype: TPlaidAccountSubTypes,
};

export default class PlaidAccount {
  id: string;
  name: string;
  institution: TPlaidAccountInstitution;
  mask: string;
  type: TPlaidAccountTypes;
  subtype: TPlaidAccountSubTypes;

  constructor(options: TPlaidAccountOptions) {
    this.id = options.id;
    this.name = options.name;
    this.institution = options.institution;
    this.mask = options.mask;
    this.type = options.type;
    this.subtype = options.subtype;
  }

  static init(options: TPlaidAccountOptions): PlaidAccount {
    return new PlaidAccount(options);
  }

  is_credit_card(): boolean {
    return this.type === PlaidAccountTypes.credit
      && this.subtype === PlaidAccountSubTypes.credit_card;
  }

  is_ach(): boolean {
    return this.type === PlaidAccountTypes.depository
      && [PlaidAccountSubTypes.checking, PlaidAccountSubTypes.savings].includes(this.subtype);
  }

  is_student_loan(): boolean {
    return this.type === PlaidAccountTypes.loan
      && this.subtype === PlaidAccountSubTypes.student;
  }

  to_verifiable_account(): VerifiableAccount {
    return VerifiableAccount.init({
      id: this.id,
      name: this.name,
      institution: this.institution,
      mask: this.mask,
      type: this.type,
      subtype: this.subtype,
    });
  }

  to_json(): TPlaidAccountOptions {
    return {
      id: this.id,
      name: this.name,
      institution: this.institution,
      mask: this.mask,
      type: this.type,
      subtype: this.subtype,
    };
  }
}
